import React from "react"

const AlternativeText = "Alternatively tap close to amend your dates or explore the map further."
const AllocateText =
  "You will be allocated a suitable pitch by the team on your arrival day. Please select your pitch type to continue with your booking."

export default function AvailabilitySummary({
  isMobile,
  isPitchBookingLimited,
  minNumberOfNightsForPitchBookings,
  isTregartonLimited,
}) {
  const getCopy = () => {
    if (isPitchBookingLimited) {
      return (
        <>
          {/* For 1 and 2 night bookings on these dates the 'Pick a Pitch' feature isn't available. <br /> */}
          For 1 and 2 night bookings the 'Pick a Pitch' feature isn't available. <br />
          <br />
          {AllocateText}
          <br />
          <br />
          {isMobile && AlternativeText}
        </>
      )
    }
    if (isTregartonLimited) {
      return (
        <>
          {minNumberOfNightsForPitchBookings} day minimum for 'Pick a Pitch' feature.
          <br />
          <br />
          {AllocateText}
          <br />
          <br />
          {isMobile && AlternativeText}
        </>
      )
    }
  }

  return (
    <div className="availability-actions">
      <div className="minimum-days-desc">{getCopy()}</div>
    </div>
  )
}
